export const QUERY_DEFAULTS = {
  staleTime: 0,
  gcTime: 5 * 60 * 1000,
  refetchOnMount: 'always' as const,
  refetchOnReconnect: true,
  refetchOnWindowFocus: false,
  retry: 1,
}

export const QUERY_KEYS = {
  vendor: (vendorId: string, includeCatalog: boolean) =>
    ['vendor', vendorId, includeCatalog] as const,
  orders: ['orders'] as const,
  ordersList: (status: string, limit: number) =>
    ['orders', 'list', status, limit] as const,
  notifications: ['notifications'] as const,
  notificationsList: (limit: number) => ['notifications', 'list', limit] as const,
  notificationsUnread: ['notifications', 'unread'] as const,
}
